(() => {
  'use strict';
  const dataElement = document.getElementById('mp-coffee-variant-data');
  if (!dataElement) return;
  const data = JSON.parse(dataElement.textContent);
  const variants = new Map(data.variants.map(variant => [variant.id, variant]));
  const urlId = new URL(location.href).searchParams.get('variant');
  let active = variants.get(urlId) || variants.get(data.selectedId);
  let scheduled = false;
  let synchronizing = false;
  const gallerySelections = new WeakMap();
  const bundleSelector = 'select[aria-label="Escolha seu kit de café"]';
  const nativeSelector = '.product-details select[name="options[Kit]"]';

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function updateMoney(container) {
    if (!container) return;
    setText(container.querySelector('.price'), active.price);
    const compare = container.querySelector('.compare-at-price');
    if (compare) {
      setText(compare, active.compare || '');
      compare.hidden = !active.compare;
    }
  }

  function updateGallery() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery || gallerySelections.get(gallery) === active.id) return;
    const slideshow = gallery.querySelector('slideshow-component');
    const slides = Array.from(gallery.querySelectorAll('slideshow-slides > slideshow-slide'));
    const filename = new URL(active.image, location.origin).pathname.split('/').pop();
    const index = slides.findIndex(slide => {
      const image = slide.querySelector('img');
      return image && new URL(image.src, location.origin).pathname.endsWith('/' + filename);
    });
    if (slideshow && index >= 0 && typeof slideshow.select === 'function') {
      slideshow.select(index, undefined, { animate: false });
      gallerySelections.set(gallery, active.id);
    }
  }

  function synchronize() {
    scheduled = false;
    if (!active || synchronizing) return;
    synchronizing = true;
    try {
      const heading = document.querySelector('[data-mp-coffee-title]');
      if (heading) {
        setText(heading.querySelector('[data-kit-weight]'), active.weightText);
        setText(heading.querySelector('[data-kit-quantity]'), active.quantityText);
        setText(heading.querySelector('[data-kit-unit]'), active.unitText);
        const saving = heading.querySelector('[data-kit-saving]');
        setText(saving, active.savingText);
        if (saving) saving.hidden = !active.compare;
      }
      document.querySelectorAll('.product-details product-price, sticky-add-to-cart [ref="priceContainer"]').forEach(updateMoney);
      document.body.classList.toggle('mp-coffee-bundle-ready', Boolean(document.querySelector(bundleSelector)));
      const native = document.querySelector(nativeSelector);
      if (native && native.value !== active.title) native.value = active.title;
      document.querySelectorAll('.product-details form input[name="id"]').forEach(input => {
        if (input.value !== active.id) input.value = active.id;
      });
      document.querySelectorAll(bundleSelector).forEach(select => {
        if (select.value === active.id) return;
        select.value = active.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      const sticky = document.querySelector('sticky-add-to-cart');
      if (sticky) {
        sticky.dataset.currentVariantId = active.id;
        setText(sticky.querySelector('[data-testid="sticky-variant-title"]'), active.title);
        const image = sticky.querySelector('[data-testid="sticky-product-image"]');
        if (image && image.getAttribute('src') !== active.image) {
          image.removeAttribute('srcset');
          image.src = active.image;
          image.alt = active.imageAlt;
        }
      }
      updateGallery();
      const url = new URL(location.href);
      if (url.searchParams.get('variant') !== active.id) {
        url.searchParams.set('variant', active.id);
        history.replaceState(history.state, '', url);
      }
    } finally {
      synchronizing = false;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(synchronize);
  }

  document.addEventListener('change', event => {
    if (synchronizing || !(event.target instanceof HTMLSelectElement)) return;
    const select = event.target;
    if (!select.matches(bundleSelector) && !select.matches(nativeSelector)) return;
    const option = select.selectedOptions[0];
    const id = variants.has(select.value) ? select.value : option?.dataset.variantId;
    if (variants.has(id)) {
      active = variants.get(id);
      schedule();
    }
  }, true);

  window.addEventListener('popstate', () => {
    const variant = variants.get(new URL(location.href).searchParams.get('variant'));
    if (variant) active = variant;
    schedule();
  });
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  customElements.whenDefined('slideshow-component').then(schedule);
  synchronize();
})();
